import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import { NavBar } from "./pages/NavBar";
import { HomePage } from "./pages/Home";
import { EnterprisesPage } from "./pages/Enterprises";
import { EnterprisePage } from "./pages/Enterprise";
import { ClientPage } from "./pages/Client";
import { SurveyPage } from "./pages/Survey";
import { ResultsPage } from "./pages/Results";
import { ExpensePage } from "./pages/Expense";
import './styles/App.css';
import "bootstrap/dist/css/bootstrap.css";
import { ProtectedComponent } from './components/login/ProtectedComponent';

// Register Community Module for AgGrid
ModuleRegistry.registerModules([ AllCommunityModule ]);

const App = () => {
    return (
      <Router>
            <NavBar />
            <div className="app-content">
              <Routes>
                <Route exact path="/"
                  element={ 
                    <ProtectedComponent>
                      <HomePage />
                    </ProtectedComponent> 
                  } 
                />
                <Route path="/enterprises/" 
                  element={ 
                    <ProtectedComponent>
                      <EnterprisesPage />
                    </ProtectedComponent> 
                  } 
                />
                <Route path="/enterprises/:id" 
                  element={ 
                    <ProtectedComponent>
                      <EnterprisePage />
                    </ProtectedComponent> 
                  } 
                />
                <Route path="/clients/:id" 
                  element={ 
                    <ProtectedComponent>
                      <ClientPage />
                    </ProtectedComponent> 
                  } 
                />
                <Route path="/results/:clientId/:surveyId" 
                  element={
                    <ProtectedComponent>
                      <ResultsPage />
                    </ProtectedComponent> 
                  } 
                />
                
                <Route path="/survey" element={<SurveyPage />} />

                <Route path="/expense" element={
                  <ProtectedComponent>
                    <ExpensePage />
                  </ProtectedComponent>
                  } 
                />
              </Routes>
            </div>
      </Router>
    );
}

export default App;
